export const TEXT_ONLY = "TEXT_ONLY";
export const FILE_UPLOAD = "FILE_UPLOAD";

export const DOCFLY_STATUS_OPEN = "aperto";
export const DOCFLY_STATUS_STORED = "conservato";
